/** @format */
import React, { useMemo } from 'react';
import { useAppTranslation } from '@/i18n/declarations';
import moment from 'moment';
import { TReducerBookingOld } from '@/ducks/booking/selectors';

interface UseAvailabilityProps {
  availableFrom?: string;
  roomAvailability: TReducerBookingOld['availability'];
}

const useAvailability = ({ availableFrom, roomAvailability }: UseAvailabilityProps) => {
  const { t } = useAppTranslation();

  const availabilityText = useMemo(() => {
    if (!roomAvailability?.availableFrom || availableFrom === 'notAvailable' || roomAvailability?.negotiating) {
      return <span>{t('recently_booked')}</span>;
    }

    if (moment(availableFrom).isSame(moment(), 'day')) {
      return <span className="today">{t('today')}</span>;
    }

    const momentFormattedFromAvailability = moment(availableFrom).format('DD MMM YY');
    return <span>{momentFormattedFromAvailability}</span>;
  }, [roomAvailability, availableFrom, t]);

  return {
    availabilityText,
  };
};

export default useAvailability;
